type TrustpilotReviewsProps = {
    id?: string;
    theme?: 'dark' | 'light';
};

export default function TrustpilotReviews({
    id = 'trustpilot-reviews',
    theme = 'dark',
}: TrustpilotReviewsProps) {
    return (
        <div
            id={id}
            title='Trustpilot Reviews'
            className='trustpilot-widget'
            data-locale='en-GB'
            data-template-id='53aa8912dec7e10d38f59f36'
            data-businessunit-id='567dd08a0000ff000586fa46'
            data-style-height='140px'
            data-style-width='100%'
            data-token='f42859f2-fbe6-4d45-9f3b-552fcebf17bf'
            data-stars='4,5'
            data-review-languages='en'
            data-font-family='Work Sans'
            data-theme={theme}
        >
            <a
                href='https://uk.trustpilot.com/review/airporttaxis-uk.co.uk'
                target='_blank'
                rel='noopener'
            >
                Trustpilot
            </a>
        </div>
    );
}
